const AppConfig = {
  title: '归州E泊管理平台',

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: false,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production',

  /**
   * @type {string} 'zh-cn' | 'en' | 'ja'
   * @description 饿了么UI组件国际化 
   */
  locale: 'zh-cn',

  /**
   * @type {boolean} true | false
   * @description 是否开启登录页粒子特效 
   */
  enableLoginParticle: false,

  
}
//export default AppConfig;
 module.exports = AppConfig
